/* eslint-disable max-len */
import RacaQuestion from 'images/coin-pages/questions/raca.svg'

import { ICoinPageData } from '../types'
import { blogCards, commonSlidesData } from '../commonPageData'

export const racaPage: ICoinPageData = {
  title: 'coin_806',
  description: 'coin_807',
  // description:
  //   'Get a Raca loan. Receive up to 90% of your RACA loan collateral in cash or crypto and continue holding. Borrow Raca instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Raca (RACA)' }) }} />
  ),
  questionsBlock: {
    image: RacaQuestion,
    questions: [
      {
        title: 'coin_808',
        answer: 'coin_809',
      },
      {
        title: 'coin_810',
        answer: 'coin_811',
      },
      {
        title: 'coin_812',
        answer: 'coin_813',
      },
      {
        title: 'coin_814',
        answer: 'coin_815',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Raca (RACA)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_816',
        text: ['coin_818'],
      },
      {
        title: 'coin_817',
        text: ['coin_819'],
      },
    ],
    blogCards: [
      blogCards.borrowLikePro,
      {
        link: 'https://coinrabbit.io/blog/can-you-buy-a-house-with-bitcoin/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/01/Can-you-buy-a-house-with-bitcoin.png',
        imageAlt: 'Can You Buy a House With Bitcoin?',
      },
      blogCards.cryptoCrash,
    ],
  },
}
